<template>
    <div class="row">
        <div class="print-product-col" :class="[ mode === 'small' ? 'col-md-8 col-lg-6' : 'col-md-6 col-lg-4' ]"
             v-for="product in products" :key="product.id">

            <article class="print-product">
                <div class="print-product__image-container">
                    <img class="box-shadow img-fluid rounded" :src="coverImage(product)">
                </div>

                <div class="print-product__body">
                    <header class="print-product__heading">
                        <div class="print-product__eyebrow">{{ product.family_name }}</div>
                        <h2 class="print-product__title">{{ product.title }}</h2>
                        <div class="print-product__subtitle">{{ product.subtitle }}</div>
                    </header>

                    <div class="print-product__description">
                        <vue-markdown>{{ product.description }}</vue-markdown>
                    </div>

                    <div v-for="variant in product.variants" :key="variant.tag" class="print-product__variant">
                        <!-- <h4>{{ variant.name }}</h4>-->
                        <div v-for="option in variant.options" :key="option.id" class="print-product__variant__option"
                             @click="selectProduct(product.id, option)">
                            <div>
                                <div class="print-product__variant__option__name">{{ option.name }}</div>
                                <div class="print-product__variant__option__price">{{ option.price_starting_from_formatted }}</div>
                            </div>
                            <button class="btn btn-primary btn-sm" :disabled="!canAddPrintItems">{{ $t('print_product_item.btn_choose') }}</button>
                        </div>
                    </div>
                </div>

                <!--                <div class="product-detail__image-top product-detail&#45;&#45;content">-->
                <!--                    <div class="product-detail&#45;&#45;content&#45;&#45;media">-->
                <!--                        <img class="box-shadow img-fluid rounded" :src="coverImage(product)">-->
                <!--                    </div>-->
                <!--                </div>-->

                <!--                <div class="product-detail&#45;&#45;footer">-->
                <!--                    <div class="product-detail&#45;&#45;footer&#45;&#45;content">-->
                <!--                        <div class="product-detail&#45;&#45;footer&#45;&#45;heading">-->
                <!--                            <div class="product-detail&#45;&#45;footer&#45;&#45;eyebrow">{{ product.family_name }}</div>-->
                <!--                            <div class="product-detail&#45;&#45;footer&#45;&#45;title">{{ product.title }}</div>-->
                <!--                            <div class="product-detail&#45;&#45;footer&#45;&#45;subtitle">{{ product.subtitle }}</div>-->
                <!--                        </div>-->

                <!--                        <div class="product-detail&#45;&#45;footer&#45;&#45;desc">-->
                <!--                             <vue-markdown>{{ product.description }}</vue-markdown>-->
                <!--                        </div>-->

                <!--                        <div v-for="variant in product.variants" :key="variant.tag">-->
                <!--&lt;!&ndash;                            <h4>{{ variant.name }}</h4>&ndash;&gt;-->
                <!--                            <div v-for="option in variant.options" :key="option.id" class="product-detail&#45;&#45;footer&#45;&#45;cta" _style="background-color: #1a64e8" @click="selectProduct(product.id, option)">-->
                <!--&lt;!&ndash;                                <div class="product-detail&#45;&#45;footer&#45;&#45;cta&#45;&#45;item&#45;&#45;in-promo">Promo</div>&ndash;&gt;-->
                <!--                                <div class="product-detail&#45;&#45;footer&#45;&#45;cta&#45;&#45;item">-->
                <!--                                    <div class="txt">{{ option.name }}</div>-->
                <!--                                </div>-->
                <!--                                <div class="product-detail&#45;&#45;footer&#45;&#45;cta&#45;&#45;price">{{ option.price_starting_from_formatted }}</div>-->
                <!--                                <button class="btn btn-primary btn-sm">seleziona</button>-->
                <!--                            </div>-->
                <!--                        </div>-->
                <!--                    </div>-->
                <!--                </div>-->
            </article>

        </div>
    </div>
</template>


<script>
    import VueMarkdown from 'vue-markdown'
    import { mapGetters } from "vuex";

    export default {
        components: {
            VueMarkdown,
        },

        props: ['mode'],

        created() {
            this.$store.dispatch('prints/getProducts')
        },

        computed: {
            ...mapGetters('cart', [
                'canAddPrintItems'
            ]),

            products() {
                return this.$store.state.prints.products
            }
        },

        methods: {
            coverImage(product) {
                if (product.gallery.length > 0)
                    return product.gallery[0].image
                return ''
            },

            // eslint-disable-next-line
            selectProduct(productId, productVariantOptionFormat) {
                console.log('productVariantOptionFormat', productVariantOptionFormat)
                this.$store.commit("prints/SET_PRODUCT_SELECTED", {
                    productId,
                    productVariantOptionFormat
                })
                this.$router.push({name: "configure-product"})
                //this.$router.push({name: 'configure-product', params: { productId: product.id }})
            }
        }
    }
</script>
